import { AlertCircle } from 'lucide-react';

export function Field({ label, children, error, helper, required, className = '' }) {
  return (
    <div className={className}>
      {label && (
        <label className="label">
          {label} {required && <span style={{ color: 'var(--danger)' }}>*</span>}
        </label>
      )}
      {children}
      {error && <div className="error-text"><AlertCircle size={12} /> {error}</div>}
      {!error && helper && <div className="helper">{helper}</div>}
    </div>
  );
}
